import React from "react";
import { useTranslation } from "react-i18next";
import {
  ErrorContainer,
  ErrorIcon,
  ErrorTitle,
  ErrorMessage,
  ErrorContact,
} from "./styled";

const Error = () => {
  const { t } = useTranslation();

  return (
    <ErrorContainer>
      <ErrorIcon>
        <i className="fa-solid fa-exclamation-triangle"></i>
      </ErrorIcon>
      <ErrorTitle>{t("error.identification.title")}</ErrorTitle>
      <ErrorMessage>{t("error.identification.message")}</ErrorMessage>
      <ErrorContact>{t("error.identification.contact")}</ErrorContact>
    </ErrorContainer>
  );
};

export default Error;
